import { z } from 'zod';
import { passwordResetBodySchema, passwordResetCheckBodySchema, } from '../../auth/reset-password-form.js';
import { signupEmailSchema } from '../../auth/signup-form.js';
/**
 * Resetting a forgotten password. Every route is `@PublicRoute()`: the person
 * has no session. Each is limited per client IP before the body is checked
 * (`patterns/auth-patterns.md`, 1).
 */
export const passwordResetEmailRequestSchema = z.object({ email: signupEmailSchema });
/**
 * Asks for a password reset email. Always `204` with nothing to return,
 * whatever the address is: unknown, removed, without a password or over its
 * cap, so the answer never reveals whether the address has a login.
 */
export const requestPasswordResetEmail = {
    method: 'POST',
    path: '/api/dashboard/password-reset-emails',
    params: z.object({}),
    query: z.object({}),
    body: passwordResetEmailRequestSchema,
    response: z.void(),
};
/**
 * `valid` gives back only the address the link already names. Every link that
 * can't be used is `invalid`, with nothing else.
 */
export const passwordResetCheckResponseSchema = z.discriminatedUnion('status', [
    z.object({ status: z.literal('valid'), email: z.email() }),
    z.object({ status: z.literal('invalid'), email: z.null() }),
]);
export const checkPasswordReset = {
    method: 'POST',
    path: '/api/dashboard/password-reset-checks',
    params: z.object({}),
    query: z.object({}),
    body: passwordResetCheckBodySchema,
    response: passwordResetCheckResponseSchema,
};
/**
 * Replaces the password, ends every session of the login and signs the person
 * in: `204` with the new session's cookie. `422 VALIDATION_FAILED` on
 * `password` for its length, or on `token` when the link can't be used.
 */
export const resetPassword = {
    method: 'POST',
    path: '/api/dashboard/password-resets',
    params: z.object({}),
    query: z.object({}),
    body: passwordResetBodySchema,
    response: z.void(),
};
//# sourceMappingURL=password-resets.js.map